import { COVERAGES_CODES } from "./coverages";

export const COVERAGE_BOXES = {
    [COVERAGES_CODES.NATURAL_DISASTER]: {
        desc: "Terremoto y otros\nriesgos de la\nnaturaleza",
    },
    [COVERAGES_CODES.CIVIL_RESPONSIBILITY]: { desc: "Daños\na vecinos\no a terceros" },
    [COVERAGES_CODES.CRYSTAL_BREAK]: {
        desc: "Rotura accidental\nde ventanas\n o mamparas",
    },
    [COVERAGES_CODES.THEFT_FIXED_INSTALLATION]: { desc: "Robo\nde instalaciones\nfijas" },
    [COVERAGES_CODES.MEDICAL_INSURED]: {
        desc: "Reembolso de gastos\nmédicos por accidente\nde trabajadores del hogar",
        small: true,
    },
    [COVERAGES_CODES.RENT_NO_RECEIVED]: {
        desc: "Alquiler no percibido\nsi tu inmueble\nqueda inhabitable",
    },
    [COVERAGES_CODES.TEMPORARY_SPENDS]: { desc: "Reembolso\nde alojamiento\ntemporal" },
    [COVERAGES_CODES.ROBBERY]: { desc: "Robo\nde bienes\ndomésticos" },
    [COVERAGES_CODES.DISAPPEAR]: { desc: "Apropiación ilícita\nde tus cosas\n(Hurto)" },
    [COVERAGES_CODES.THEFT_ESPECIAL]: { desc: "Robo de\nbienes\nde alto valor" },
    [COVERAGES_CODES.DISHONESTY]: { desc: "Deshonestidad\nde trabajadores\ndel hogar" },
    [COVERAGES_CODES.ASSISTS]: { desc: "Paquete de\nasistencias" },
};

export const ROOMER_CUSTOM_PLAN_COVERAGE_BOXES = [
    COVERAGES_CODES.NATURAL_DISASTER,
    COVERAGES_CODES.ROBBERY,
    COVERAGES_CODES.DISAPPEAR,
    COVERAGES_CODES.THEFT_ESPECIAL,
    COVERAGES_CODES.DISHONESTY,
    COVERAGES_CODES.ASSISTS,
];

export const ROOMER_FIXED_PLAN_COVERAGE_BOXES = [
    COVERAGES_CODES.NATURAL_DISASTER,
    COVERAGES_CODES.ROBBERY,
    COVERAGES_CODES.THEFT_ESPECIAL,
    COVERAGES_CODES.ASSISTS,
];

export const OWNER_RENT_CUSTOM_PLAN_COVERAGE_BOXES = [
    COVERAGES_CODES.NATURAL_DISASTER,
    COVERAGES_CODES.CIVIL_RESPONSIBILITY,
    COVERAGES_CODES.CRYSTAL_BREAK,
    COVERAGES_CODES.THEFT_FIXED_INSTALLATION,
    COVERAGES_CODES.MEDICAL_INSURED,
    COVERAGES_CODES.RENT_NO_RECEIVED,
    COVERAGES_CODES.TEMPORARY_SPENDS,
    COVERAGES_CODES.ASSISTS,
];

export const OWNER_RENT_FIXED_PLAN_COVERAGE_BOXES = [
    COVERAGES_CODES.NATURAL_DISASTER,
    COVERAGES_CODES.CIVIL_RESPONSIBILITY,
    COVERAGES_CODES.ASSISTS,
];

export const OWNER_LIVE_CUSTOM_PLAN_COVERAGE_BOXES = [
    COVERAGES_CODES.NATURAL_DISASTER,
    COVERAGES_CODES.CRYSTAL_BREAK,
    COVERAGES_CODES.CIVIL_RESPONSIBILITY,
    COVERAGES_CODES.THEFT_FIXED_INSTALLATION,
    COVERAGES_CODES.MEDICAL_INSURED,
    COVERAGES_CODES.RENT_NO_RECEIVED,
    COVERAGES_CODES.TEMPORARY_SPENDS,
    COVERAGES_CODES.ROBBERY,
    COVERAGES_CODES.DISAPPEAR,
    COVERAGES_CODES.THEFT_ESPECIAL,
    COVERAGES_CODES.DISHONESTY,
    COVERAGES_CODES.ASSISTS,
];

export const OWNER_LIVE_FIXED_PLAN_COVERAGE_BOXES = [
    COVERAGES_CODES.NATURAL_DISASTER,
    COVERAGES_CODES.CIVIL_RESPONSIBILITY,
    COVERAGES_CODES.ROBBERY,
    COVERAGES_CODES.THEFT_ESPECIAL,
    COVERAGES_CODES.ASSISTS,
];
